import { useCallback } from 'react';
import cn from 'classnames';

import ICO_BRANDING from 'assets/images/online-booking/Branding-purple.svg';
import OverlaySpinner from 'components/generic/OverlaySpinner.component';
import TooltipForReceptionist from 'components/TooltipForReceptionist';
import IN from 'constants/in';
import { useTranslation } from 'providers/GILT.provider';
import { useNcobSettings } from 'providers/NcobSettings.provider';
import { useThemeWithBright } from 'providers/Theme.provider';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';

import FileUpload from 'settings/online-booking/pages/branding/FileUpload.component';
import WidgetColorMode from 'settings/online-booking/pages/branding/WidgetColorMode.component';
import PageTitle from 'settings/online-booking/pages/PageTitle.component';
import SectionContent from 'settings/online-booking/pages/SectionContent.component';
import SectionTitle from 'settings/online-booking/pages/SectionTitle.component';

import CN from './BrandingPanel.module.scss';

const L = logger('BrandingPanel');

const BrandingPanel = () => {
  const { isBrightMode, isDarkMode, isLightMode } = useThemeWithBright();
  const { value, isLoading, error, update } = useNcobSettings();
  const { t } = useTranslation();

  const { ncobMode } = asObject(value);

  const handleSaveColorMode = useCallback(
    //
    ({ raw }) => void (raw && update({ data: { ncobMode: raw.id } })),
    [update],
  );

  if (error) L.warn('()', { ncobMode, isLoading, error, value });

  return (
    <div
      data-bem="BrandingPanel"
      className={cn({
        [CN.component]: true,
        [CN.lightMode]: isLightMode,
        [CN.darkMode]: isDarkMode,
        [CN.brightMode]: isBrightMode,
      })}
    >
      {isLoading && <OverlaySpinner />}

      <PageTitle icon={ICO_BRANDING} alt="Branding icon">
        {t('onlineBooking.brandingPanel.title')}
      </PageTitle>

      <SectionTitle tag="BrandingPanel__color-title" value={t('onlineBooking.brandingPanel.colourMode')}>
        {t('onlineBooking.brandingPanel.themeDescription')}
      </SectionTitle>

      <SectionContent tag="BrandingPanel__color-content">
        <WidgetColorMode
          tag="BrandingPanel__color-mode"
          name="color_type"
          onChange={handleSaveColorMode}
          value={ncobMode}
        />
        <TooltipForReceptionist where={IN.colorSettings} />
      </SectionContent>

      <SectionTitle tag="BrandingPanel__logo-title" value={t('onlineBooking.brandingPanel.logo')}>
        {t('onlineBooking.brandingPanel.logoDescription')}
      </SectionTitle>

      <SectionContent tag="BrandingPanel__logo-content">
        <FileUpload />
      </SectionContent>
    </div>
  );
};

export default BrandingPanel;
